import { acceptStringValue } from '../../field-viewer/shared-normalizers';
import { resolveDefaultTimeValue } from './time-input-default-value';
export const timeInputViewer = {
    resolveDefault: resolveDefaultTimeValue,
    normalizeLoadedValue: acceptStringValue
};

//# sourceMappingURL=definition-viewer.js.map